import { hyphenated, removeDiacritics } from "./string";

export const FALLBACK_URL = 'https://your-page.com';

export function getBaseUrl(url: string) {
    try {
        const parsedUrl = new URL(url);
        return `${parsedUrl.protocol}//${parsedUrl.host}`;
    } catch (e) {
        return '';
    }
}

export function getSuggestedUrl(baseUrl: string, keyword: string,): string {
    return `${baseUrl}/${hyphenated(removeDiacritics(keyword)).toLowerCase()}`;
}

export function getSlug(url: string): string {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.pathname.replace(/\/+$/, '').split('/').pop() || '';
    } catch (e) {
        return '';
    }
}

function tokenize(value: string): string[] {
    return removeDiacritics(value)
        .toLowerCase()
        .split(/[^a-z0-9]+/i)
        .filter(Boolean);
}

export function urlPathContainsKeyword(url: string, keyword: string): boolean {
    const query = (keyword || '').trim();
    if (!url || !query) {
        return false;
    }
    let path = url;
    try {
        path = decodeURIComponent(new URL(url).pathname);
    } catch {
        // keep the raw string when it is not a full URL
    }
    const pathTokens = tokenize(path.replace(/\/+$/, ''));
    const rawKeywordTokens = tokenize(query);
    const keywordTokens = rawKeywordTokens.length === 1
        ? rawKeywordTokens
        : rawKeywordTokens.filter((word) => word.length > 1);
    if (!pathTokens.length || !keywordTokens.length) {
        return false;
    }
    return keywordTokens.every((word) =>
        pathTokens.some((token) => token === word || (word.length >= 3 && token.includes(word)))
    );
}